module.exports = __webpack_public_path__ + "static/GreenAmerica-logo-White-a1122fdd0373414ed8e32c3a4103766e.png";